import { configureStore } from '@reduxjs/toolkit'
import usersReducer from './user'

export default configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: {
    users: usersReducer,
  },
})
